import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

import {FORM_ADD_ON_ID} from './consts';
import type {CustomAddOn} from './custom-add-on-select-modal';

type Props = {
    variant: CustomAddOn;
};

export function ModalEmptyState(props: Props) {
    const getTitle = (): string => {
        let noun;
        if (props.variant === FORM_ADD_ON_ID) {
            noun = 'forms';
        } else {
            noun = 'meetings';
        }

        return `No ${noun} available`;
    };

    const getSubtitle = (): string => {
        let noun;
        if (props.variant === FORM_ADD_ON_ID) {
            noun = 'Forms';
        } else {
            noun = 'Scheduler';
        }

        return `First, create one in Nutshell ${noun}. Then, return here to add it to your page.`;
    };

    const getCta = (): React.ReactElement => {
        let route, linkText;
        if (props.variant === FORM_ADD_ON_ID) {
            route = '/email-marketing/forms';
            linkText = 'Visit Nutshell Forms';
        } else {
            route = '/scheduler';
            linkText = 'Visit Nutshell Scheduler';
        }

        return (
            // @ts-expect-error
            <Link size='big' variant='button-primary' as={RoutedLink} to={route} replace={true}>
                {linkText}
            </Link>
        );
    };

    return (
        <div className='flex align-center justify-center full-height'>
            <EmptyStateLarge
                title={getTitle()}
                subtitle={getSubtitle()}
                cta={getCta()}
                icon={
                    <div style={{width: 140}}>
                        <Illustration src='cactus-empty-state' width='100%' height='100%' />
                    </div>
                }
            />
        </div>
    );
}
